import type sv from '../sv/documents'

const documents: typeof sv = {
  list: {
    searchPlaceholder: 'Search for files…',
    noSearchResults: 'No files matched your search',
    columns: {
      name: 'Name',
      date: 'Date',
      size: 'Size',
      owner: 'Owner',
    },
    selectAll: 'Select all',
    rowMenu: 'More actions',
    selectedCount_one: '{{count}} selected',
    selectedCount_other: '{{count}} selected',
    addToTag: 'Add to tag',
    deleteSelected: 'Delete',
    clearSelection: 'Clear selection',
    dropOverlay: 'Drop the files here to upload',
    bulkDeleteDialog: {
      title: 'Delete files',
      description_one: 'Are you sure you want to delete {{count}} file? This cannot be undone.',
      description_other: 'Are you sure you want to delete {{count}} files? This cannot be undone.',
    },
    sortLabel: 'Sort:',
    sortUpdated: 'Last updated',
    sortName: 'Name',
    listView: 'List view',
    gridView: 'Grid view',
    reindex: 'Reindex',
    regenerateMarkdown: 'Regenerate markdown',
    upload: 'Upload',
    newDocument: 'New document',
    showTags: 'Show tags',
    hideTags: 'Hide tags',
    loading: 'Loading...',
    empty: 'No documents',
    uploadFiles: 'Upload files',
    createDocument: 'Create document',
    updated: 'Updated {{date}}',
    delete: 'Delete',
    manageTags: 'Manage tags',
    noTagsYet: 'No tags created yet',
    maxTags: 'Max {{count}} tags',
    documentCount_one: '{{count}} document',
    documentCount_other: '{{count}} documents',
    conversion: {
      converting: 'Converting...',
      completed: 'Done',
      failed: 'Failed',
    },
    deleteDialog: {
      title: 'Delete document',
      description: 'Are you sure you want to delete "{{title}}"? This cannot be undone.',
      cancel: 'Cancel',
      confirm: 'Delete',
      deleting: 'Deleting...',
    },
  },
  meetingNotes: {
    writing: 'HUB is writing the meeting notes…',
    failed: 'HUB could not write the meeting notes. Ask an administrator to rerun them.',
  },
  editor: {
    loadError: 'Could not load the document',
    loadingPdf: 'Loading PDF...',
    loadingEditor: 'Loading editor...',
    converting: 'Converting document...',
    loadingSpreadsheet: 'Loading spreadsheet...',
    loadingImage: 'Loading picture...',
  },
  spreadsheet: {
    loadError: 'Could not load the spreadsheet',
    empty: 'The spreadsheet is empty',
    rows_one: '{{count}} row',
    rows_other: '{{count}} rows',
    showingFirst: 'Showing the first {{count}} rows',
    search: 'Search the table...',
    noMatches: 'No rows match',
    download: 'Download original file',
  },
  tags: {
    all: 'All',
    untagged: 'Untagged',
    rename: 'Rename',
    recolor: 'Change colour',
    delete: 'Delete',
    new: 'New tag',
    namePlaceholder: 'Tag name...',
    cancel: 'Cancel',
    create: 'Create',
    save: 'Save',
    colors: {
      gray: 'Grey',
      red: 'Red',
      orange: 'Orange',
      yellow: 'Yellow',
      green: 'Green',
      teal: 'Teal',
      blue: 'Blue',
      indigo: 'Indigo',
      purple: 'Purple',
      pink: 'Pink',
    },
    renameDialog: {
      title: 'Rename tag',
    },
    recolorDialog: {
      title: 'Change tag colour',
      description: 'Choose a new colour for <strong>{{name}}</strong>',
    },
    deleteDialog: {
      title: 'Delete tag',
      description:
        'The tag <strong>{{name}}</strong> will be deleted. Documents with the tag are not affected.',
    },
  },
  upload: {
    uploading: 'Uploading…',
    uploadDone: 'Upload finished',
    dismiss: 'Dismiss',
    dropHere: 'Drop files here or <pick>click to choose</pick>',
    hint: 'PDF, Word, Excel, PowerPoint, CSV, TXT, pictures (max 50 MB, pictures 20 MB)',
    hintWithAudio:
      'PDF, Word, Excel, PowerPoint, CSV, TXT, pictures, audio/video (max 50 MB, pictures 20 MB)',
    unknownType: '(unknown)',
    unsupportedType:
      'The file type {{ext}} is not supported. Use PDF, Word, Excel, PowerPoint, CSV, TXT or a picture (PNG, JPG, GIF, WebP, HEIC).',
    unsupportedTypeWithAudio:
      'The file type {{ext}} is not supported. Use PDF, Word, Excel, PowerPoint, CSV, TXT, a picture (PNG, JPG, GIF, WebP, HEIC) or an audio/video file.',
    tooLarge: 'The file is too large ({{size}}). Max {{max}}.',
    failed: 'Upload failed',
    networkError: 'Network error',
  },
  viewer: {
    defaultFilename: 'document.pdf',
    loadError: 'Could not load the PDF file',
    print: 'Print',
    downloadPdf: 'Download PDF',
    downloadOriginal: 'Download original',
    loading: 'Loading PDF...',
    zoom: 'Zoom',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    fitWidth: 'Fit to width',
    zoomPercent: '{{percent}}%',
    image: {
      loadError: 'Could not show the picture',
      failed: 'The picture could not be read. Download the original or upload it again.',
      openLarge: 'Show full size',
      description: 'Description (AI)',
      describing: 'HUB is describing the picture…',
    },
  },
  drawings: {
    sortLabel: 'Sort:',
    sortUpdated: 'Last updated',
    sortName: 'Name',
    create: 'Create new whiteboard',
    createFirst: 'Create your first whiteboard',
    newTitle: 'Board {{date}}',
    loading: 'Loading...',
    loadingBoard: 'Loading whiteboard...',
    loadError: 'Could not load the whiteboard',
    empty: 'No whiteboards yet',
    updated: 'Updated {{date}}',
    deleteDialog: {
      title: 'Delete whiteboard',
      description: 'Are you sure you want to delete "{{title}}"? This cannot be undone.',
      cancel: 'Cancel',
      confirm: 'Delete',
      deleting: 'Deleting...',
    },
  },
  whiteboard: {
    loading: 'Loading whiteboard...',
    syncing: 'Syncing whiteboard...',
    untitled: 'New whiteboard',
    unknownUser: 'Unknown',
    saved: 'Saved',
    saving: 'Saving...',
    saveFailed: 'Failed',
    save: 'Save',
  },
}

export default documents
